import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function NoviWhy() {
  return <section className="py-24 bg-paper border-b border-subtle-gray" data-id="element-2720">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2721">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2722">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-2723">
            Why Novi Families Choose Storm
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-2724">
          {['A quick, easy drive from anywhere in Novi', "Olympic-level coaching you won't find at average gyms", 'Structured programs that Novi parents trust for character development', 'Family classes so parents and kids can train together'].map((reason, idx) => <div key={idx} className="flex items-start gap-4 bg-off-white p-6 rounded-2xl border border-subtle-gray" data-id="element-2725">
              <CheckCircle2 className="w-8 h-8 text-storm-red shrink-0" data-id="element-2726" />
              <p className="text-lg text-ink font-medium" data-id="element-2727">{reason}</p>
            </div>)}
        </div>
      </div>
    </section>;
}